import React, { useState } from "react";
import { categories, nutrients, searchCatalog, decideReview, syncFood } from "./api";

export default function ReviewItem({ reviewId, item, catalogSync, token, onChange }) {
  const [name, setName] = useState(item.name);
  const [category, setCategory] = useState(item.category || "기타");
  const [values, setValues] = useState(item.proposal);
  const [reason, setReason] = useState("");
  const [q, setQ] = useState(item.name);
  const [found, setFound] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function run(action, refresh = true) {
    setBusy(true); setError("");
    try { await action(); if (refresh) await onChange(); } catch (e) { setError(e.message); } finally { setBusy(false); }
  }
  async function decide(action) {
    let body = { action };
    if (action === "approve") {
      if (!name.trim() || nutrients.some(([key, , , max]) => values[key] === "" || !Number.isFinite(Number(values[key])) || Number(values[key]) < 0 || Number(values[key]) > max)) {
        setError("음식명과 모든 영양성분을 올바르게 입력해주세요."); return;
      }
      body.food = { name: name.trim(), category, nutrition: Object.fromEntries(nutrients.map(([key]) => [key, Number(values[key])])) };
    } else if (action === "link") {
      if (!selectedId) { setError("연결할 기존 음식을 선택해주세요."); return; }
      body.foodId = selectedId;
    } else {
      if (!reason.trim()) { setError("반려 사유를 입력해주세요."); return; }
      body.reason = reason.trim();
    }
    await run(() => decideReview(token, reviewId, item.index, body));
  }
  if (item.status !== "pending") return <section className="review-item">
    <h3>{item.name}</h3><p>{item.status === "approved" ? "DB 승인 완료" : "반려 완료"}{item.reason ? ` · ${item.reason}` : ""}</p>
    {item.foodId && catalogSync[item.foodId] === "pending" && <button disabled={busy} onClick={() => run(() => syncFood(token, reviewId, item.foodId))}>검색 반영 재시도</button>}
    {error && <p role="alert">{error}</p>}
  </section>;
  return <section className="review-item" aria-label={`${item.name} 검토`}>
    <h3>미등록 음식 · {item.name}</h3>
    <p>AI 추정 제안입니다. 사진·음식명·영양성분을 검토한 후 승인해주세요. 모든 수치는 <strong>100g 기준</strong>입니다.</p>
    <fieldset disabled={busy}>
      <label>음식명<input value={name} maxLength={100} onChange={e => setName(e.target.value)} /></label>
      <label>분류<select value={category} onChange={e => setCategory(e.target.value)}>{categories.map(value => <option key={value}>{value}</option>)}</select></label>
      <div className="nutrient-grid">{nutrients.map(([key, label, unit, max]) => <label key={key}>{label} ({unit})<input type="number" min="0" max={max} step="any" value={values[key]} onChange={e => setValues({ ...values, [key]: e.target.value })} /></label>)}</div>
      <button className="primary" onClick={() => decide("approve")}>수정한 영양정보로 DB에 추가</button>
      <details><summary>기존 음식과 연결</summary>
        <p>동일 음식이 이미 있다면 기존 항목에 연결합니다. 이후 같은 음식명의 사진 분석에 활용됩니다.</p>
        <label>기존 음식 검색<input value={q} maxLength={100} onChange={e => setQ(e.target.value)} /></label>
        <button onClick={() => run(async () => { const result = await searchCatalog(token, q.trim()); setFound(result.data); setSelectedId(""); }, false)} disabled={!q.trim()}>검색</button>
        {found.length > 0 && <label>연결 대상<select value={selectedId} onChange={e => setSelectedId(e.target.value)}><option value="">선택해주세요</option>{found.map(food => <option key={food.id} value={food.id}>{food.name} · {food.calorie} kcal</option>)}</select></label>}
        <button onClick={() => decide("link")} disabled={!selectedId}>선택한 기존 음식에 연결</button>
      </details>
      <details><summary>반려</summary><label>반려 사유<textarea maxLength={500} value={reason} onChange={e => setReason(e.target.value)} /></label><button onClick={() => decide("reject")} disabled={!reason.trim()}>반려하기</button></details>
    </fieldset>
    {error && <p role="alert">{error}</p>}
  </section>;
}
